import React from "react";
import { useNavigate } from "react-router-dom";
import svg10 from "../../assets/svg/svg10.svg";
import svg172 from "../../assets/svg/svg172.svg";
import svg176 from "../../assets/svg/svg176.svg";
import svg177 from "../../assets/svg/svg177.svg";
import svg178 from "../../assets/svg/svg178.svg";
import svg179 from "../../assets/svg/svg179.svg";
import svg180 from "../../assets/svg/svg180.svg";
import svg181 from "../../assets/svg/svg181.svg";
import svg182 from "../../assets/svg/svg182.svg";

const items = [
  {
    icon: svg176,
    title: "Bulk Payments",
    desc: "Pay hundreds in minutes via bank or mobile money.",
    navigationId: "/services/bulk-payment",
  },
  {
    icon: svg177,
    title: "Petty Cash",
    desc: "Track every shilling spent on office errands and micro-tasks.",
    navigationId: "/services/petty-cash",
  },
  {
    icon: svg178,
    title: "Bills & Suppliers",
    desc: "Automate supplier invoices. Never miss a payment deadline.",
    navigationId: "/services/bill-settlement",
  },
  {
    icon: svg179,
    title: "Airtime",
    desc: "Keep teams connected with automated airtime top-ups.",
    navigationId: "/services/airtime-data",
  },
  {
    icon: svg182,
    title: "Group Payments",
    desc: "Pay teams in one go based on specific projects or locations.",
    navigationId: null,
  },
  {
    icon: svg181,
    title: "Standing Orders",
    desc: "Automate recurring payments for rent or recurring services.",
    navigationId: null,
  },
  {
    icon: svg180,
    title: "Casual Workforce",
    desc: "Pay workers instantly. Scale from 10 to 10,000 workers with ease using our massive ledger capability.",
    navigationId: null,
  },
];

function Payments() {
  const navigate = useNavigate();

  const handleLogin = () => {
    window.location.href = "https://app.impaladigitalpayment.com/#/login";
  };

  const handleRegister = () => {
    window.location.href = "https://app.impaladigitalpayment.com/#/registration";
  };

  const handleCardClick = (navigationId) => {
    if (navigationId) navigate(navigationId);
  };

  return (
    <div className="flex flex-col items-center">
      {/* Header */}
      <div className="text-ink text-center font-lexend text-[1.75rem] md:text-[2.25rem] font-[600] leading-[2.625rem] tracking-[-0.0405rem] w-full">
        Run Payments, Workforce &amp; Expenses in One System
      </div>
      <div className="mt-[.75rem] text-center text-body font-lexend text-[1.125rem] font-[400] leading-[1.5rem] tracking-[-0.01125rem] w-full">
        From paying 10 staff to 10,000+ casual workers. Impala Digital Payments gives you full control.
      </div>

      {/* CTAs */}
      <div className="lg:mt-[3rem] mt-[1rem] flex flex-wrap items-center justify-center gap-[.75rem]">
        <button className="cstm-btn-2 !w-auto !min-w-0 group transition-all duration-500 ease-in-out" onClick={() => navigate("/request-demo")}>
          Request a demo
          <img
            src={svg10}
            alt="arrow"
            className="w-3 h-3 overflow-hidden opacity-0 group-hover:w-[1.25rem] group-hover:opacity-100 group-hover:ml-[.375rem] transition-all duration-500 ease-in-out"
          />
        </button>
        <button className="cstm-btn !w-auto !min-w-0" onClick={() => window.open("https://wa.me/254716644981", "_blank")}>
          Chat On WhatsApp <img src={svg172} alt="whatsapp" />
        </button>
      </div>

      {/* Cards — 2 rows of 4 */}
      <div className="lg:mt-[4.56rem] mt-[2rem] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[1.5rem] w-full">
        {items.map((item, index) => (
          <div
            key={index}
            onClick={() => handleCardClick(item.navigationId)}
            className={`rounded-[1.25rem] bg-white shadow-[0_2px_10px_0_rgba(35,31,32,0.10)] p-[1.5rem] flex flex-col gap-[.75rem] ${index === 6 ? "sm:col-span-2 lg:col-span-2" : ""} ${item.navigationId ? "cursor-pointer hover:shadow-[0_4px_20px_0_rgba(0,0,0,0.12)] transition-shadow" : ""}`}
          >
            <img src={item.icon} alt={item.title} className="w-[3rem] h-[3rem] object-contain" />
            <div className="text-ink font-lexend text-[1.125rem] font-[600] leading-[1.625rem]">
              {item.title}
            </div>
            <div className="text-body font-lexend text-[.875rem] font-[400] leading-[1.5rem]">
              {item.desc}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Payments;
